import { getImage, GatsbyImage } from "gatsby-plugin-image";
import EmbedMap from "../../../../src/components/blogparts/embedmap";
import EmbedYoutube from "../../../../src/components/blogparts/embedyoutube";
import ExternalLink from "../../../../src/components/blogparts/externallink";
import SingleImg from "../../../../src/components/blogparts/singleimg";
import TwoFlexImg from "../../../../src/components/blogparts/twofleximg";
import ArticleFooter from "../../../../src/components/blogparts/articlefooter";
import AccessCard from "../../../../src/components/blogparts/accesscard";
import DestInfo from "../../../../src/components/blogparts/destinfo";
import Balloon from "../../../../src/components/blogparts/balloon";
import MoshimoAffiliate from "../../../../src/components/blogparts/moshimoaffiliate";
import * as styles from "../../../../src/styles/basemdx.module.scss";
import * as React from 'react';
export default {
  getImage,
  GatsbyImage,
  EmbedMap,
  EmbedYoutube,
  ExternalLink,
  SingleImg,
  TwoFlexImg,
  ArticleFooter,
  AccessCard,
  DestInfo,
  Balloon,
  MoshimoAffiliate,
  styles,
  React
};